/// <amd-module name="Search/Code/Components/TreeFilterBarItem" />

import * as React from "react";
import { format } from "VSS/Core/Util/String";
import * as Resources from "Search/Code/Resources";
import * as SharedResources from "Search/Shared/Resources";
import { TreeFilter } from "Search/Code/Components/TreeFilter";
import { FilterBarItem, IFilterBarItemState, IFilterBarItemProps } from "SearchUI/FilterBar";
import { getId } from "VSS/Core/Util/Object";

export interface ITreeFilterBarItemProps extends IFilterBarItemProps {
    enabled: boolean;

    project?: string;

    repository?: string;

    branch?: string;

    requestedPath?: string;

    onSelectionChanged(name: string, path: string): void;
}

export class TreeFilterBarItem extends FilterBarItem<string, ITreeFilterBarItemProps, IFilterBarItemState<string>> {
    public focus(): void {
    }

    public forceUpdate(): void {
    }

    public render(): JSX.Element {
        const {
            enabled,
            project,
            repository,
            branch,
            requestedPath
        } = this.props;
        const treeDropdownId = getId("tree-filter-dropdown");
        return (
            <TreeFilter
                treeDropdownId={treeDropdownId}
                enabled={enabled}
                project={project}
                repository={repository}
                branch={branch}
                comboBoxText={requestedPath}
                comboBoxLabel={Resources.PathDisplayLabel}
                placeholder={Resources.PathTreePlaceholderText}
                applyButtonAriaLabel={format(SharedResources.ApplyFilterAriaLabel, Resources.PathDisplayLabel)}
                clearIconAriaLabel={format(SharedResources.ClearFilterAriaLabel, Resources.PathDisplayLabel)}
                disabledInfoCalloutProps={
                    {
                        title: SharedResources.RefineFiltersText,
                        content: Resources.PathFilterCalloutContent
                    }
                }
                onSelectionChanged={this.onSelectionChanged}
            />
        );
    }

    private onSelectionChanged = (path: string): void => {
        this.setFilterValue({ value: [path] });
        if (this.props.onSelectionChanged) {
            this.props.onSelectionChanged(this.props.filterItemKey, path);
        }
    }
}
